<template>
  <f7-page id="axsr-reg-redirect" name="axsr-reg-redirect" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <f7-block>
      <div id="loader-container"></div>
      <div class="text-align-center">{{$t('axs-loading-text')}}</div>
    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import lottie from 'lottie-web';
  import loadingDefault from '@/assets/img/loading/loading_wandr_default.json';

  export default {
    async mounted (){
      //this.showPreloader()
      
      const loaderContainer = document.getElementById("loader-container")
      lottie.loadAnimation({
          container: loaderContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: loadingDefault
      })


      const appRedirPath = await this.$api.misc.checkDeviceRedirect()
      let self = this
      setTimeout(function() {
        //console.log("appRedirPath : "+appRedirPath)
        if(appRedirPath){
          window.location.href = appRedirPath;
          return;
        }
        self.determineAppBranchId(self.$f7.device.desktop)
      }, 5000);
      
      },
    data() {
      return {
        loadingText : ""
      };
    },
    methods: {
      ...mapActions('registration', []),
      ...mapActions('misc', ['determineAppBranchId']),
      afterin(){
        
      },
      async init(){
        
      },

      
    },
    components: {
      
    },
    computed: {
      ...mapGetters('registration', [
        
      ]),
    },
  }
</script>